import { Actions, ofType, createEffect } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { createAction, props, on, createSelector } from '@ngrx/store';
import { EntityStoreFactory, IGenericEntityState } from '@pit/core-store';
import { IDtoUser } from '@pit/frontend-model';
import { EntityDataServiceAccessorService } from '@pit/core-data';
import { IDtoUserEntityDataService } from '../../module.data/services/interfaces/dto.user.entity.data.service.interface';
import { UtilsMisc } from '@pit/core';

export class DtoUserStoreFactory extends EntityStoreFactory<IDtoUser> {

    private static _instance: DtoUserStoreFactory = null;

    public static get instance(): DtoUserStoreFactory {
        if (this._instance === null) {
            this._instance = new DtoUserStoreFactory();
        }

        return this._instance;
    }

    constructor() {
        super('DtoUser', 'dto.user');
    }

    protected override doCreateActions(): void {
        super.doCreateActions();

        this.entityActions.add('load.for.web', createAction(
            'Load Users For Web',
            props<{ mandatorId: number }>()
        ));
        this.entityActions.add('load.for.web.success', createAction(
            'Load Users For Web Success',
            props<{ items: IDtoUser[] }>()
        ));
        this.entityActions.add('load.for.web.failure', createAction(
            'Load Users For Web Failure',
            props<{ error: any }>()
        ));
    }

    protected override doCreateEffects(): void {
        super.doCreateEffects();

        this.entityEffects.add('load.for.web', {
            effect: (actions$: Actions, dataServiceAccessor: EntityDataServiceAccessorService) => {
                return createEffect(() =>
                    actions$.pipe(
                        ofType(this.getAction('load.for.web')),
                        map(action => action),
                        switchMap(action =>
                            (dataServiceAccessor.getEntityDataService<IDtoUser>(this.dataAccessName) as IDtoUserEntityDataService)
                                .getWebUsersForMandator$(action.mandatorId).pipe(
                                    map(items => this.getAction('load.for.web.success')({ items: items })),
                                    catchError(error => of(this.getAction('load.for.web.failure')({ error: error })))
                                )
                        )
                    )
                );
            }
        });
    }

    protected override doCreateSelectors() {
        super.doCreateSelectors();

        this.entitySelectors.add('get.users.mobile', createSelector(
            this.getSelector('get.all.entities'),
            (items: IDtoUser[]) => items.filter(item => (item.isMobileUser === true)).sort((a, b) => {
                try {
                    return (parseInt(a.number) - parseInt(b.number));
                } catch (error) {
                    return 0;
                }
            })
        ));
        this.entitySelectors.add('get.users.web', createSelector(
            this.getSelector('get.all.entities'),
            (items: IDtoUser[]) => items.filter(item => (item.isWebUser === true)).sort((a, b) => {
                try {
                    return (parseInt(a.number) - parseInt(b.number));
                } catch (error) {
                    return 0;
                }
            })
        ));
        this.entitySelectors.add('get.users.web.for.user', (user: IDtoUser) => createSelector(
            this.getSelector('get.all.entities'),
            (items: IDtoUser[]) => items.filter(item => {
                let result: boolean = (item.isWebUser === true);
                if (result === true) {
                    result = ((user.isAdmin === true) ||
                        (user.depots.some(depot => (UtilsMisc.isNullOrUndefined(item.depots.find(x => (x.id === depot.id))) === false))));
                }
                return result;
            }).sort((a, b) => {
                try {
                    return (parseInt(a.number) - parseInt(b.number));
                } catch (error) {
                    return 0;
                }
            })
            /*(items: IDtoUser[]) => items.filter(item => (item.isWebUser === true)).sort((a, b) => {
                try {
                    return (parseInt(a.number) - parseInt(b.number));
                } catch (error) {
                    return 0;
                }
            })*/
        ));
    }

    protected override doGetReducers<S extends IGenericEntityState<IDtoUser>>(): any {
        const result: any = super.doGetReducers();

        result.push(
            on(
                this.getAction('load.for.web'),
                (state: any, { showLoadingIndicator }) => {
                    return {
                        ...state,
                        loading: ((showLoadingIndicator === true) ? true : state.loading)
                    };
                }
            )
        );
        result.push(
            on(
                this.getAction('load.for.web.failure'),
                (state: any) => {
                    return {
                        ...state,
                        loading: ((state.loading === true) ? false : state.loading)
                    };
                }
            )
        );
        result.push(
            on(this.getAction('load.for.web.success'), (state: any, { items }) => {
                let res: any = state;
                for (let loop = 0; loop < items.length; loop++) {
                    const item: any = items[loop];
                    res = this.entityAdapter.setOne(item, {
                        ...res
                    });
                    if ((UtilsMisc.isNullOrUndefined(state.selectedItem) === false) && (state.selectedItem.id === item.id)) {
                        res = {
                            ...res,
                            selectedItem: res.entities[item.id]
                        };
                    }
                }
                res = {
                    ...res,
                    loading: ((state.loading === true) ? false : state.loading)
                };
                return res;
            })
        );

        return result;
    }

}
